import React from 'react'
import styled from 'styled-components'

const NewsletterStyle = styled.div`
  overflow: hidden;
  position: relative;
  margin-bottom: 25px;

  h2 {
    margin-bottom: 4px;
  }
  
  h5 {
    margin-bottom: 15px;
  }

  form {
    position: relative;
    z-index: 99999;
    font-weight: 500;

    display: grid;
    grid-template-columns: 1fr min-content;
    grid-gap: 10px;

    @media screen and (max-width: 374px) {
      grid-template-columns: 1fr;
    }

    .emailInput {
      border: solid 3px #0B33F8;
      text-align: left;
      padding: 10px;
      color: #0B33F8;
      font-weight: 500;
      letter-spacing: 0.5px;

      :focus {
        outline: none;
      }
    
      ::placeholder {
        color: #0B33F8;
        opacity: 0.7;
      }
    }

    .submitInput {
      border: solid 3px #0B33F8;
      background: #0B33F8;
      color: white;
      padding: 10px 15px;
      font-size: 1em;
      font-weight: 500;
      letter-spacing: 0.5px;
      cursor: pointer;

      :focus {
        outline: none;
      }

      ::placeholder {
        color: #0B33F8;
        opacity: 0.7;
      }

      @media screen and (max-width: 374px) {
        justify-self: left;
        padding: 6px 10px;
      }
    }
  }
`;

export default class SpecialFormEmail extends React.Component {
  render() {
    return (
      <NewsletterStyle>
        <h2>Iscriviti alla Newsletter</h2>
        <h5>Prossimi eventi e iniziative sul territorio</h5>
        <form action="https://tinyletter.com/proloco-ozzero" method="post" target="popupwindow"  onSubmit={function(){window.open('https://tinyletter.com/proloco-ozzero', 'popupwindow', 'scrollbars=yes,width=800,height=600'); return true}}>
          <input className="emailInput" type="email" name="email" id="tlemail" placeholder="email@site.com"/>
          <input type="hidden" name="embed" value="1"/>
          <input className="submitInput" type="submit" value="Iscriviti"/>
        </form>
      </NewsletterStyle>
    )
  }
}